import React from "react";
import "./Blog_Cards.css";
import { useNavigate } from "react-router-dom";
import Read_More_btn from "../../common-btn/redirect-btn/read-more-btn/Read_More_btn";

const Blog_Cards = ({ img, date, title, description, id }) => {
  const navigate = useNavigate();
  const handleBlogClick = (id) => {
    navigate(`/blogs/${id}`);
  };

  return (
    <div className="Blog_Card">
      <div className="img_wrapper">
        <img src={img} className="card_img" alt={title} />
      </div>
      <div className="card_body">
        <p className="card_date">{date}</p>
        <h5 className="card_title">{title}</h5>
        <p className="card_text">{description}</p>
        <Read_More_btn
          btnText="Read More"
          link="/blogs/detail-blog"
          onClick={() => handleBlogClick(id)}
        />
      </div>
    </div>
  );
};

export default Blog_Cards;
